<template>
  <va-card :title="$t('menu.loads')">
    <div class="row">

      <div class="flex xs12 md3">
        <va-input
          v-model="search"
          :label="$t('menu.search')"
          removable
        >
        </va-input>
      </div>

      <div class="flex md1">
        <va-button
          small
          color="secondary"
          icon="fa fa-search"
          class="ma-2"
          @click="readItems(page, search)"
        >
          {{ $t('menu.search') }}
        </va-button>
      </div>
      <div class="flex xs12 md2 offset--md3">
        <va-select
          v-model="perPage"
          :value="perPage"
          :label="$t('tables.perPage')"
          :options="perPageOptions"
        />
      </div>
    </div>

    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

    <va-data-table
      v-if="renderComponent"
      :fields="fields"
      :data="data"
      :per-page="parseInt(perPage)"
      :total-pages="parseInt(totalPages)"
      v-show="!loading"
      no-pagination
      api-mode
      @page-selected="readItems"
    >

      <!-- <template slot="actions" slot-scope="props">

      </template> -->
    </va-data-table>

    <Pagination
      :currentPage="current_page"
      :totalPages="totalPages"
      :onChange="onPageChange"
      v-show="!loading"
    />
  </va-card>
</template>

<script>
import { mapState } from "vuex";
import { Ability } from '@casl/ability'

export const ability = new Ability()

import AuditAPI from '@/services/AuditAPI'
import * as spinners from 'epic-spinners'
import { showError } from '@/global'

import Pagination from '../shared/Pagination'


export default {
  name: 'modals',
  components: {
    ...spinners,
    Pagination
  },
  data () {
    return {
      data: [],
      loading: false,
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      showModal: false,
      ability: [],
      codeLoad: '',
      perPage: "10",
      totalPages: 0,
      perPageOptions: ['10', '20', '30', '50'],
      search: '',
      renderComponent: true,
      current_page: '',
      last_refresh: new Date()
    }
  },

  channels: {
    NeedRefreshAudits: {
      received(data) {
        this.readItems()
      },
    }
  },

  beforeMount(){
    this.ability = ability.update(this.rules)
  },

  mounted () {
    this.$cable.subscribe({ channel: 'NeedRefreshAudits', company: this.currentUser.company })

    this.perPage = (this.$route.params.perPage !== undefined) ? `${this.$route.params.perPage}` : "10"
    this.search = (this.$route.params.search !== undefined) ? `${this.$route.params.search}` : ""

    this.readItems(this.$route.params.current_page,this.search)
  },

  computed: {
    ...mapState(['rules', 'currentLocality', 'currentUser']),

    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.audits.id'),
      },
      {
        name: 'auditable_id',
        title: this.$t('tables.audits.auditable_id'),
      },
      {
        name: 'user_name',
        title: this.$t('tables.audits.user_name'),
      },
      {
        name: 'action',
        title: this.$t('tables.audits.action'),
      },
      {
        name: 'audited_changes',
        title: this.$t('tables.audits.audited_changes'),
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    spload () {
      return spinners.ScalingSquaresSpinner
    }
  },
  watch: {
    perPage: function (newVal) {
      this.perPage = newVal
      this.readItems(this.current_page)
    },
    search: function (newVal) {
      if (!newVal) {
        this.readItems()
      }
    },

    '$store.state.currentLocality': function() {
      this.readItems()
    }
  },
  methods: {
    onPageChange(page) {
      this.readItems(page)
    },

    async readItems(page = 0, search) {
      this.loading = true

      const params = {
        page: page,
        quantity: this.perPage,
        search: this.search
      }
      this.current_page = this.$route.params.current_page

      await AuditAPI.getFilteredAudits(params)
        .then(response => {
          this.totalPages = response.data.total_pages
          this.current_page = response.data.current_page
          this.data = response.data.audits
          this.loading = false
      });
    },
  }
}
</script>
